<div class="dialog-container">
  <div class="dialog-header">
    <h4>{{ "report.actions.selectLanguage" | translate }}</h4>
  </div>
  <div class="container">
    <div class="section-container content">
      <span>{{ "report.actions.languageSelectionDefinition" | translate }}</span>
    </div>
    <div class="section-container language-container">
      <sag-ui-select [label]="'report.item.language' | translate" [value]="selectedLanguage" [required]="true" (change)="changeLanguage($event)">
        <sag-ui-option value="en">{{ "default.languages.en" | translate }}</sag-ui-option>
        <sag-ui-option value="de">{{ "default.languages.de" | translate }}</sag-ui-option>
      </sag-ui-select>
    </div>
  </div>
  <div class="container container--sticky-bottom">
    <div class="section-container button-container">
      <sag-ui-button color="secondary" (click)="dialogRef.close()">
        {{ "default.buttons.cancel" | translate }}
      </sag-ui-button>
      <sag-ui-button color="primary" (click)="selectLanguage()" [disabled]="!selectedLanguage">
        {{ "default.buttons.save" | translate }}
      </sag-ui-button>
    </div>
  </div>
</div>
